import Cookies from 'js-cookie';
import { headersMiddleware, bodyMiddleware } from '@aspectus/resource';

const getCsrfToken = () => {
  if (typeof document !== 'undefined') {
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (meta) {
      const value = meta.getAttribute('content');
      if (value) return value;
    }
  }
  return Cookies.get('csrftoken');
};

export const xCSRFMiddleware = headersMiddleware(parameters => {
  const token = getCsrfToken();
  if (!token) {
    if (typeof console !== 'undefined') {
      console.warn('CSRF token not found in meta or cookie');
    }
    return parameters;
  }
  return { ...parameters, 'X-CSRFToken': token };
});

export const multipartRequestMiddleware = bodyMiddleware(
  body => Object.keys(body).reduce(
    (acc, x) => {
      const value = Array.isArray(body[x]) ? body[x] : [body[x]];
      value.forEach(v => acc.append(x, v));

      return acc;
    },
    new FormData()
  )
);
